import * as React from 'react';
import {
  styled,
  AppBar,
  Box,
  Toolbar,
  Button,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import COLORS from '../Colors';
import SwitchToggleTimeFormat from './SwitchToggleTimeFormat';

const StyledNavBar = styled(AppBar)(() => ({
  backgroundColor: COLORS.SLATE900,
}));

const StyledButtonInAppBar = styled(Button)(() => ({
  border: `2px solid ${COLORS.SLATE300}`,
  color: COLORS.SLATE300,
  fontWeight: 'bold',
  textTransform: 'capitalize',
}));

const SearchAppBar = ({
  liftingLogout,
}) => (
  <Box sx={{ flexGrow: 0 }}>
    <StyledNavBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ flexGrow: 1 }}
          // display: { xs: 'none', sm: 'block' }
        >
          Caebes
        </Typography>
        <SwitchToggleTimeFormat />
        <StyledButtonInAppBar
          variant="outlined"
          size="large"
          startIcon={<LogoutIcon />}
          sx={{ px: 2 }}
          onClick={liftingLogout}
        >
          Salir
        </StyledButtonInAppBar>
      </Toolbar>
    </StyledNavBar>
  </Box>
);

export default SearchAppBar;
